import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import {MainModule} from "./main/main.module";
import {AppRoutingModule} from "./app-routing.module";
import { NavComponent } from './nav.component';
import { FooterComponent } from './footer.component';
import {ResumeModule} from "./resume/resume.module";
import {ContactModule} from "./contact/contact.module";
import {SharedModule} from "./shared/shared.module";
import {WebsitesModule} from "./websites/websites.module";
import {JavascriptModule} from "./javascript/javascript.module";

@NgModule({
  declarations: [
    AppComponent,
    NavComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    MainModule,
    ResumeModule,
    ContactModule,
    SharedModule,
    WebsitesModule,
    JavascriptModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts